import React from 'react';
import PropTypes from 'prop-types';

import { VpIcon } from '../VpIcon';

import { StyledSocialButton } from './styles';

export const VpShareToEmail = ({ link = '', post = '' }) => {
  const subject = encodeURIComponent('Check this out!');
  const body = encodeURIComponent(`${post}\n\nCheck it out: ${link}`);
  const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

  return (
    <a href={mailtoLink}>
      <StyledSocialButton variant="contained">
        <VpIcon icon="Email" />
      </StyledSocialButton>
    </a>
  );
};

VpShareToEmail.propTypes = {
  link: PropTypes.string,
  post: PropTypes.string
};

export default VpShareToEmail;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpSocialMediaShareButtons/VpShareToEmail.jsx